(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const hash = window.location.hash;
      if (!hash) return;

      const card = document.getElementById(hash.slice(1));
      if (!card) return;

      requestAnimationFrame(() => {
        card.scrollIntoView({ behavior: 'auto', block: 'center' });

        const cleanUrl = `${window.location.pathname}${window.location.search}`;
        window.history.replaceState({}, document.title, cleanUrl);
      });
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();
})();
